/**
 * Created by intellicar-rinas on 17/1/18.
 */
import React, {Component} from 'react';
import './MobileyeReportToolBar.css';


class MobileyeReportToolBar extends Component {

    componentDidMount() {
        this.props.data.buttons.map(button=> {
            button.updateSchema =()=> {
                if(!this.mounted) return;
                this.forceUpdate()
            };
            button.getSchema =()=> this.props.data.getSchema();
        });
    }

    onClick =button=> {
        if(button.onClick) {
            button.onClick(button);
        }
    };

    componentWillMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        return (
            <div className="MobileyeReportToolBar">
                {this.props.data.buttons.map((button, index)=> {
                    return (
                        <div className={"mrtb-button" + (button.active ? ' -active' : '') + ' ' + (button.className || '')} key={index}
                             style={(button.style || {})}
                             onClick={()=>this.onClick(button)}>
                             {(button.active ? button.nameActive : button.name) || button.name}
                        </div>
                    )
                })}
            </div>
        )
    }

}

export default MobileyeReportToolBar;

